module.exports = __webpack_public_path__ + "static/media/power_off.55d7a09c.ico";